import React from "react";
import "./css/AboutUs.css";
import pictureOne from "./assets/picOne.png";
import headerBg from "./assets/picOne.png"; // optional background image

const ApplicationForTC = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Application for Technical Committees</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) welcomes applications from individuals 
            and organizations interested in participating in the formulation of national standards. 
            Technical Committees are composed of representatives from industry, government, 
            non-governmental organizations, professional bodies, consumers, and other interested parties.
          </p>
          <p className="subtitle">
            By joining a Technical Committee, you contribute to shaping standards that ensure 
            quality, safety, and efficiency across Malawi’s industries.
          </p>
        </div>
      </section>

      {/* === How to Apply Section === */}
      <section className="intro-section">
        <h2 className="section-title">How to Apply</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Check the current list of active Technical Committees on the MBS website.</li>
              <li>Identify the committee(s) relevant to your area of expertise or interest.</li>
              <li>Prepare a brief profile including your professional background and experience.</li>
              <li>Include any relevant affiliations with professional bodies or organizations.</li>
              <li>Complete the MBS Technical Committee Application Form.</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Attach a copy of your CV and any supporting documents.</li>
              <li>Submit your application via email to <a href="mailto:info@mbs.mw">info@mbs.mw</a> or deliver it to the MBS office.</li>
              <li>Applications are reviewed by the Technical Committees Secretariat.</li>
              <li>Successful applicants will be contacted for participation and orientation.</li>
              <li>Membership is voluntary and requires active participation in committee meetings and activities.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Inquiries</h2>
        <p>
          For more information about Technical Committee membership or the application process, 
          please contact the MBS Secretariat:
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:info@mbs.mw">info@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 123</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Address: Malawi Bureau of Standards</li>
              <li>P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
      </section>

      <br /><br />
    </div>
  );
};

export default ApplicationForTC;
